import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import tvplan_en from './en/tvplan.json';
import tvplan_fr from './fr/tvplan.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        interpolation: {
            escapeValue: false
        },
        react: {
            wait: true,
            useSuspense: false
        },
        debug: false,
        fallbackLng: 'en',
        lng: 'en',
        whitelist: ['en', 'fr'],
        resources: {
            en: {
                tvplan: tvplan_en
            },
            fr: {
                tvplan: tvplan_fr
            }
        }
    });

export default i18n;